/* tslint:disable */
/* eslint-disable */
/**
 * Swagger LogisticProcess - OpenAPI 3.0
 * Collaborator of the warehouse
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface ColMessageResponse {
    'message'?: string;
}
export interface ColPartialRequest {
    'id'?: number;
    'name'?: string;
    'uuid'?: string;
    'username'?: string;
    'email'?: string;
    'role'?: string;
    'teamId'?: number;
    'dni'?: string;
    'sapNumber'?: string;
    'siteFedidCodes'?: Array<SiteFedidCodeRequest>;
    'manual'?: boolean;
}
export interface ColPartialResponse {
    'id'?: number;
    'name'?: string;
    'uuid'?: string;
    'sapNumber'?: string;
    'dni'?: string;
    'username'?: string;
    'email'?: string;
    'manual'?: boolean;
    'siteFedidCodes'?: Array<SiteFedidCodeRequest>;
}
export interface ColTeam {
    'id'?: number;
    'name'?: string;
}
export interface CollaboratorCreatedResponse {
    'message'?: string;
    'code'?: string;
}
export interface CollaboratorResponse {
    'id'?: number;
    'name'?: string;
    'username'?: string;
    'sapNumber'?: string;
    'team'?: ColTeam;
    'uuid'?: string;
    'manual'?: boolean;
    'siteFedidCodes'?: Array<SiteFedidCodeRequest>;
}
export interface ColsPartialResponse {
    'pagination'?: PaginationResponse;
    'content'?: Array<ColPartialResponse>;
}
export interface CreateCollaboratorCommandRequest {
    'uuid': string;
    'name': string;
    'siteCodeFedid': string;
    'professionalEmail': string;
}
/**
 * Pagination object. It contains all related to pagination attributes.
 */
export interface PaginationResponse {
    'currentPage'?: number;
    'pageSize'?: number;
    'totalPages'?: number;
    'pageElements'?: number;
    'totalElements'?: number;
    'isLastPage'?: boolean;
}
export interface SiteFedidCodeRequest {
    'siteCode'?: string;
}
export interface UserResponse {
    'content'?: Array<UserResponseContentInner>;
}
export interface UserResponseContentInner {
    'uid'?: string;
    'ldapUuid'?: string;
    'firstName'?: string;
    'lastName'?: string;
    'mail'?: string;
    'service'?: string;
    'centerName'?: string;
    'branch'?: string;
    'fullName'?: string;
    'manual'?: boolean;
}

/**
 * CollaboratorsApi - axios parameter creator
 */
export const CollaboratorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary delete collaborator by id
         * @param {number} id delete collaborator by id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id)
            const localVarPath = `/v1/collaborators/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new Collaborator
         * @summary Create Collaborator
         * @param {CreateCollaboratorCommandRequest} createCollaboratorCommandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollaborator: async (createCollaboratorCommandRequest: CreateCollaboratorCommandRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCollaboratorCommandRequest' is not null or undefined
            assertParamExists('createCollaborator', 'createCollaboratorCommandRequest', createCollaboratorCommandRequest)
            const localVarPath = `/v1/collaborators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCollaboratorCommandRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create Collaborator
         * @summary Create Collaborator
         * @param {ColPartialRequest} colPartialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollaboratorManually: async (colPartialRequest: ColPartialRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'colPartialRequest' is not null or undefined
            assertParamExists('createCollaboratorManually', 'colPartialRequest', colPartialRequest)
            const localVarPath = `/v1/collaborators/manual`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(colPartialRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get by id full data
         * @summary get by id full data
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIdFullData: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getByIdFullData', 'id', id)
            const localVarPath = `/v1/collaborators/{id}/partial`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Collaborator by ID
         * @summary Get collaborator by ID
         * @param {number} id Collaborator by ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollaboratorById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCollaboratorById', 'id', id)
            const localVarPath = `/v1/collaborators/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Collaborator by Team Id
         * @summary Get collaborator by team id
         * @param {number} teamId List Collaborators By Team Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollaboratorByTeamId: async (teamId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getCollaboratorByTeamId', 'teamId', teamId)
            const localVarPath = `/v1/collaborators/team/{team_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get collaborator by UUID
         * @summary Get collaborator by UUID
         * @param {string} uuid Collaborator by UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollaboratorByUUID: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getCollaboratorByUUID', 'uuid', uuid)
            const localVarPath = `/v1/collaborators/uuid/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Collaborator Information by Mail
         * @summary Get collaborator by work email
         * @param {string} mail Collaborator info by mail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollaboratorInformationByMail: async (mail: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mail' is not null or undefined
            assertParamExists('getCollaboratorInformationByMail', 'mail', mail)
            const localVarPath = `/v1/collaborators/email/{mail}`
                .replace(`{${"mail"}}`, encodeURIComponent(String(mail)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Collaborator Information by Mail
         * @summary Get collaborators by username
         * @param {string} username Collaborators by username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollaboratorsByUsername: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getCollaboratorsByUsername', 'username', username)
            const localVarPath = `/v1/collaborators/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Collaborators partial by Team Id
         * @summary Get collaborator limited response by team id
         * @param {number} teamId List Collaborators limited response By Team Id
         * @param {number} [page] Page number of the requested page
         * @param {number} [size] Number of items per page
         * @param {string} [sort] sort items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollaboratorsPartialByTeamId: async (teamId: number, page?: number, size?: number, sort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getCollaboratorsPartialByTeamId', 'teamId', teamId)
            const localVarPath = `/v1/collaborators/team/{team_id}/partial`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Collaborator
         * @summary update Collaborator
         * @param {number} id Collaborator Id for update
         * @param {ColPartialRequest} colPartialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCollaborator: async (id: number, colPartialRequest: ColPartialRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCollaborator', 'id', id)
            // verify required parameter 'colPartialRequest' is not null or undefined
            assertParamExists('updateCollaborator', 'colPartialRequest', colPartialRequest)
            const localVarPath = `/v1/collaborators/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(colPartialRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CollaboratorsApi - functional programming interface
 */
export const CollaboratorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CollaboratorsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary delete collaborator by id
         * @param {number} id delete collaborator by id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollaboratorsApi._delete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new Collaborator
         * @summary Create Collaborator
         * @param {CreateCollaboratorCommandRequest} createCollaboratorCommandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCollaborator(createCollaboratorCommandRequest: CreateCollaboratorCommandRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollaboratorCreatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCollaborator(createCollaboratorCommandRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollaboratorsApi.createCollaborator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create Collaborator
         * @summary Create Collaborator
         * @param {ColPartialRequest} colPartialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCollaboratorManually(colPartialRequest: ColPartialRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ColMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCollaboratorManually(colPartialRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollaboratorsApi.createCollaboratorManually']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * get by id full data
         * @summary get by id full data
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIdFullData(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ColPartialResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIdFullData(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollaboratorsApi.getByIdFullData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Collaborator by ID
         * @summary Get collaborator by ID
         * @param {number} id Collaborator by ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollaboratorById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollaboratorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollaboratorById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollaboratorsApi.getCollaboratorById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Collaborator by Team Id
         * @summary Get collaborator by team id
         * @param {number} teamId List Collaborators By Team Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollaboratorByTeamId(teamId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CollaboratorResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollaboratorByTeamId(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollaboratorsApi.getCollaboratorByTeamId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get collaborator by UUID
         * @summary Get collaborator by UUID
         * @param {string} uuid Collaborator by UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollaboratorByUUID(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollaboratorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollaboratorByUUID(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollaboratorsApi.getCollaboratorByUUID']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Collaborator Information by Mail
         * @summary Get collaborator by work email
         * @param {string} mail Collaborator info by mail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollaboratorInformationByMail(mail: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollaboratorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollaboratorInformationByMail(mail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollaboratorsApi.getCollaboratorInformationByMail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Collaborator Information by Mail
         * @summary Get collaborators by username
         * @param {string} username Collaborators by username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollaboratorsByUsername(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollaboratorsByUsername(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollaboratorsApi.getCollaboratorsByUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Collaborators partial by Team Id
         * @summary Get collaborator limited response by team id
         * @param {number} teamId List Collaborators limited response By Team Id
         * @param {number} [page] Page number of the requested page
         * @param {number} [size] Number of items per page
         * @param {string} [sort] sort items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollaboratorsPartialByTeamId(teamId: number, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ColsPartialResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollaboratorsPartialByTeamId(teamId, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollaboratorsApi.getCollaboratorsPartialByTeamId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Collaborator
         * @summary update Collaborator
         * @param {number} id Collaborator Id for update
         * @param {ColPartialRequest} colPartialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCollaborator(id: number, colPartialRequest: ColPartialRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ColMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCollaborator(id, colPartialRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CollaboratorsApi.updateCollaborator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CollaboratorsApi - factory interface
 */
export const CollaboratorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CollaboratorsApiFp(configuration)
    return {
        /**
         * 
         * @summary delete collaborator by id
         * @param {number} id delete collaborator by id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new Collaborator
         * @summary Create Collaborator
         * @param {CreateCollaboratorCommandRequest} createCollaboratorCommandRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollaborator(createCollaboratorCommandRequest: CreateCollaboratorCommandRequest, options?: RawAxiosRequestConfig): AxiosPromise<CollaboratorCreatedResponse> {
            return localVarFp.createCollaborator(createCollaboratorCommandRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create Collaborator
         * @summary Create Collaborator
         * @param {ColPartialRequest} colPartialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollaboratorManually(colPartialRequest: ColPartialRequest, options?: RawAxiosRequestConfig): AxiosPromise<ColMessageResponse> {
            return localVarFp.createCollaboratorManually(colPartialRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * get by id full data
         * @summary get by id full data
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIdFullData(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ColPartialResponse> {
            return localVarFp.getByIdFullData(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Collaborator by ID
         * @summary Get collaborator by ID
         * @param {number} id Collaborator by ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollaboratorById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<CollaboratorResponse> {
            return localVarFp.getCollaboratorById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Collaborator by Team Id
         * @summary Get collaborator by team id
         * @param {number} teamId List Collaborators By Team Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollaboratorByTeamId(teamId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<CollaboratorResponse>> {
            return localVarFp.getCollaboratorByTeamId(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get collaborator by UUID
         * @summary Get collaborator by UUID
         * @param {string} uuid Collaborator by UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollaboratorByUUID(uuid: string, options?: RawAxiosRequestConfig): AxiosPromise<CollaboratorResponse> {
            return localVarFp.getCollaboratorByUUID(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Collaborator Information by Mail
         * @summary Get collaborator by work email
         * @param {string} mail Collaborator info by mail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollaboratorInformationByMail(mail: string, options?: RawAxiosRequestConfig): AxiosPromise<CollaboratorResponse> {
            return localVarFp.getCollaboratorInformationByMail(mail, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Collaborator Information by Mail
         * @summary Get collaborators by username
         * @param {string} username Collaborators by username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollaboratorsByUsername(username: string, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.getCollaboratorsByUsername(username, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Collaborators partial by Team Id
         * @summary Get collaborator limited response by team id
         * @param {number} teamId List Collaborators limited response By Team Id
         * @param {number} [page] Page number of the requested page
         * @param {number} [size] Number of items per page
         * @param {string} [sort] sort items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollaboratorsPartialByTeamId(teamId: number, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<ColsPartialResponse> {
            return localVarFp.getCollaboratorsPartialByTeamId(teamId, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Collaborator
         * @summary update Collaborator
         * @param {number} id Collaborator Id for update
         * @param {ColPartialRequest} colPartialRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCollaborator(id: number, colPartialRequest: ColPartialRequest, options?: RawAxiosRequestConfig): AxiosPromise<ColMessageResponse> {
            return localVarFp.updateCollaborator(id, colPartialRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CollaboratorsApi - object-oriented interface
 */
export class CollaboratorsApi extends BaseAPI {
    /**
     * 
     * @summary delete collaborator by id
     * @param {number} id delete collaborator by id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public _delete(id: number, options?: RawAxiosRequestConfig) {
        return CollaboratorsApiFp(this.configuration)._delete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new Collaborator
     * @summary Create Collaborator
     * @param {CreateCollaboratorCommandRequest} createCollaboratorCommandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCollaborator(createCollaboratorCommandRequest: CreateCollaboratorCommandRequest, options?: RawAxiosRequestConfig) {
        return CollaboratorsApiFp(this.configuration).createCollaborator(createCollaboratorCommandRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create Collaborator
     * @summary Create Collaborator
     * @param {ColPartialRequest} colPartialRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCollaboratorManually(colPartialRequest: ColPartialRequest, options?: RawAxiosRequestConfig) {
        return CollaboratorsApiFp(this.configuration).createCollaboratorManually(colPartialRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get by id full data
     * @summary get by id full data
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getByIdFullData(id: number, options?: RawAxiosRequestConfig) {
        return CollaboratorsApiFp(this.configuration).getByIdFullData(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Collaborator by ID
     * @summary Get collaborator by ID
     * @param {number} id Collaborator by ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCollaboratorById(id: number, options?: RawAxiosRequestConfig) {
        return CollaboratorsApiFp(this.configuration).getCollaboratorById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Collaborator by Team Id
     * @summary Get collaborator by team id
     * @param {number} teamId List Collaborators By Team Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCollaboratorByTeamId(teamId: number, options?: RawAxiosRequestConfig) {
        return CollaboratorsApiFp(this.configuration).getCollaboratorByTeamId(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get collaborator by UUID
     * @summary Get collaborator by UUID
     * @param {string} uuid Collaborator by UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCollaboratorByUUID(uuid: string, options?: RawAxiosRequestConfig) {
        return CollaboratorsApiFp(this.configuration).getCollaboratorByUUID(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Collaborator Information by Mail
     * @summary Get collaborator by work email
     * @param {string} mail Collaborator info by mail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCollaboratorInformationByMail(mail: string, options?: RawAxiosRequestConfig) {
        return CollaboratorsApiFp(this.configuration).getCollaboratorInformationByMail(mail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Collaborator Information by Mail
     * @summary Get collaborators by username
     * @param {string} username Collaborators by username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCollaboratorsByUsername(username: string, options?: RawAxiosRequestConfig) {
        return CollaboratorsApiFp(this.configuration).getCollaboratorsByUsername(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Collaborators partial by Team Id
     * @summary Get collaborator limited response by team id
     * @param {number} teamId List Collaborators limited response By Team Id
     * @param {number} [page] Page number of the requested page
     * @param {number} [size] Number of items per page
     * @param {string} [sort] sort items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCollaboratorsPartialByTeamId(teamId: number, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig) {
        return CollaboratorsApiFp(this.configuration).getCollaboratorsPartialByTeamId(teamId, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Collaborator
     * @summary update Collaborator
     * @param {number} id Collaborator Id for update
     * @param {ColPartialRequest} colPartialRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCollaborator(id: number, colPartialRequest: ColPartialRequest, options?: RawAxiosRequestConfig) {
        return CollaboratorsApiFp(this.configuration).updateCollaborator(id, colPartialRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



